export default "//static.tradera.net/touchweb/static/output/images/suggestion-fallback-sm.a3ac2c43.jpg";